import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import InternalStack_module from "./InternalStack.module.js";
import { combineClasses } from "../../../utilities/combineClasses.js";
import { InternalFlexBox } from "../../flexBox/internal/InternalFlexBox.js";
const InternalStack = /*#__PURE__*/ forwardRef(({ children, className, direction = 'column', recursive = false, gap = '300', ...flexBoxProps }, ref)=>/*#__PURE__*/ jsx(InternalFlexBox, {
        className: combineClasses(className, InternalStack_module.stack, recursive && InternalStack_module.recursive),
        "data-direction": direction,
        "data-gap": gap,
        ...flexBoxProps,
        ref: ref,
        children: children
    }));
InternalStack.displayName = 'InternalStack';
export { InternalStack };
